<template>
  <div id="main-box" style="overflow:auto;">
    <div class="page">
      <!-- <el-card> -->
      <div>
        <el-form label-width="100px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="供应商">
                <el-input v-model="queryForm.SupplierName" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item>
                <div class="flex">
                  <el-button type="primary" @click="search">查询</el-button>
                  <el-button @click="empty">重置</el-button>
                  <toolbar class="mgl10" :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <!--            <el-form-item label="状态">-->
          <!--              <el-select size="small" v-model="isAccess" @change="changeStatus">-->
          <!--                <el-option :value="true" label="已对接"></el-option>-->
          <!--                <el-option :value="false" label="未对接"></el-option>-->
          <!--              </el-select>-->
          <!--              &lt;!&ndash;              <el-select v-model="queryForm.isAccess" placeholder="请选择">&ndash;&gt;-->
          <!--              &lt;!&ndash;                <el-option&ndash;&gt;-->
          <!--              &lt;!&ndash;                    v-for="item in statusOptions"&ndash;&gt;-->
          <!--              &lt;!&ndash;                    :key="item.value"&ndash;&gt;-->
          <!--              &lt;!&ndash;                    :label="item.label"&ndash;&gt;-->
          <!--              &lt;!&ndash;                    :value="item.value">&ndash;&gt;-->
          <!--              &lt;!&ndash;                </el-option>&ndash;&gt;-->
          <!--              &lt;!&ndash;              </el-select>&ndash;&gt;-->
          <!--            </el-form-item>-->
          <!--            </el-form-item>-->
        </el-form>
      </div>
      <el-table id="user-table" :data="userList" highlight-current-row v-loading="tableLoading"
        @selection-change="handleSelectionChange" style="width: 100%" border>
        <el-table-column prop="id" label="供货商ID" align="center"></el-table-column>
        <el-table-column prop="proSupplierName" label="供应商名称" align="center"></el-table-column>
        <el-table-column label="自动采购" align="center">
          <template slot-scope="scope">
            {{ scope.row.isAutoPurchase ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column label="API对接状态" align="center">
          <template slot-scope="scope">
            {{ scope.row.sysSupplierId > 0 ? '已对接' : '未对接' }}
          </template>
        </el-table-column>
        <el-table-column prop="contactName" label="联系人" align="center"></el-table-column>
        <el-table-column prop="contactNumber" label="电话" align="center"></el-table-column>
        <el-table-column label="地址" align="center">
          <template slot-scope="scope">
            {{ scope.row.province }},
            {{ scope.row.city }},
            {{ scope.row.district }}
            <br />
            {{ scope.row.detailedAddress }}
          </template>
        </el-table-column>
        <!--          <el-table-column-->
        <!--              prop="creteTime"-->
        <!--              label="创建时间"-->
        <!--              align="center"-->
        <!--          ></el-table-column>-->
        <el-table-column width="450" label="操作" align="center" fixed="right">
          <!--            <template slot-scope="scope">-->
          <!--              <toolbar-->
          <!--                  :buttonList="buttonList_table"-->
          <!--                  :funcParams="scope.row"-->
          <!--                  @callFunction="callFunction"-->
          <!--              ></toolbar>-->
          <!--            </template>-->
          <template slot-scope="scope">
            <!--              <el-button size="mini" v-for="(item, index) in buttonList_table" :key="index" :type="item.buttonType"-->
            <!--                         @click="callFunctionRow(item, index, scope.row)">{{ item.displayName }}-->
            <!--              </el-button>-->
            <div style="display: flex; flex-wrap: wrap">
              <el-button style="margin:10px" v-if="isEdit" type="primary" size="small" @click="supplierEdit(scope.row)">
                编辑
              </el-button>
              <el-button style="margin:10px" v-if="isShow" type="primary" size="small" @click="show(scope.row)">
                查看
              </el-button>
              <el-button style="margin:10px" v-if="isFetchPro" type="primary" size="small" @click="fetchPro(scope.row)">
                拉取商品
              </el-button>
              <el-button style="margin:10px" v-if="isBindSysDistributor" type="primary" size="small"
                @click="bindSysDistributor(scope.row)">绑定系统供应商
              </el-button>
              <el-button style="margin:10px" v-if="isAutoPurchase" type="primary" size="small"
                @click="autoPurchase(scope.row)">
                {{ scope.row.isAutoPurchase ? '关闭自动采购' : '开启自动采购' }}
              </el-button>
              <el-button v-if="isPoint" style="margin:10px" type="primary" size="small" @click="setPoint(scope.row)">
                自动点位设置
              </el-button>
            </div>

            <!--              <el-button v-if="isAutoPurchase" v-else type="primary" size="small" @click="autoPurchase(scope.row)">开启自动采购-->
            <!--              </el-button>-->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="total, sizes, prev, pager, next, jumper" class="pagination" :total="total"
        :current-page="queryForm.PageIndex" :pageSize="queryForm.PageSize" @current-change="handleCurrentChange"
        @size-change="handleSizeChange"></el-pagination>
      <!-- </el-card> -->
    </div>

    <el-dialog title="添加商品" :visible.sync="addProductDialog" v-if="addProductDialog" v-model="addProductDialog"
      :close-on-click-modal="false" width="80%">
      <el-form :inline="true" ref="addProductForm" :model="addProductForm">
        <el-form-item label="选择分销商">
          <el-select size="small" v-model="addProductForm.distributor">
            <el-option :value="null" label="全部"></el-option>
            <el-option :value="true" label="正常"></el-option>
            <el-option :value="false" label="禁用"></el-option>
          </el-select>
        </el-form-item>
        <div style="background-color: #F3F3F3;padding: 20px 20px 0 20px;border-radius: 6px;margin-bottom: 20px;">
          <el-form-item label="商品spuid:">
            <el-input v-model="addProductForm.SpuId" placeholder="请输入商品Id"></el-input>
          </el-form-item>
          <el-form-item label="商品名称:">
            <el-input v-model="addProductForm.ProName" placeholder="请输入商品名称"></el-input>
          </el-form-item>
          <el-form-item label="商品型号:">
            <el-input v-model="addProductForm.ProCode" placeholder="请输入型号"></el-input>
          </el-form-item>
          <el-form-item label="商品类型">
            <el-cascader v-model="addProductForm.ProTypeId"
              :props="{ value: 'Id', label: 'TypeName', children: 'Childrens' }" :show-all-levels="false"
              :options="productNavTypeTreeList" placeholder="请选择类型"></el-cascader>
          </el-form-item>
          <el-form-item label="商品品牌">
            <el-select :disabled="brandId != null" v-model="addProductForm.ProBrandId" filterable allow-create
              default-first-option placeholder="请选择品牌">
              <el-option v-for="(item, index) in brandList" :key="index" :label="item.value" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="margin-left: 40px">
            <el-button type="primary" @click="searchFun(1)">查询</el-button>
            <el-button type="danger" @click="resetFun">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
      <el-table :data="addProductList" @selection-change="handleSelectionChange" border>
        <el-table-column type="selection" width="50" fixed align="center"></el-table-column>
        <el-table-column prop="SpuId" label="SpuId" min-width="80" align="center"></el-table-column>
        <el-table-column prop="ProName" label="商品名称" align="center" min-width="350"></el-table-column>
        <el-table-column prop="ProTypeName" label="商品类型" min-width="110" align="center"></el-table-column>
        <el-table-column prop="ProBrandName" label="商品品牌" min-width="110" align="center"></el-table-column>
        <el-table-column prop="ProCode" label="商品型号" min-width="110" align="center"></el-table-column>
        <el-table-column prop="CostPrice" label="成本价" min-width="110" align="center">
        </el-table-column>
      </el-table>
      <!--      <el-pagination-->
      <!--          layout="total, sizes, prev, pager, next, jumper"-->
      <!--          style="float: right"-->
      <!--          :total="total"-->
      <!--          :current-page="queryForm.PageIndex"-->
      <!--          :pageSize="queryForm.PageSize"-->
      <!--          @current-change="handleCurrentChange"-->
      <!--          @size-change="handleSizeChange"-->
      <!--      ></el-pagination>-->
      <div slot="footer" class="dialog-footer" style="width:100%;">
        <el-button @click.native="addProductDialog = false">取消</el-button>
        <el-button type="primary" @click.native="submitAddPro" :loading="submitLoading">下一步</el-button>
      </div>
    </el-dialog>


    <el-dialog title="添加分销商" :visible.sync="addDistributorDialog" v-if="addDistributorDialog"
      v-model="addDistributorDialog" :close-on-click-modal="false">
      <el-form :model="warehouseForm" label-width="120px" :rules="warehouseFormRules" ref="warehouseForm">
        <el-form-item label="分销商名称" prop="name">
          <el-input v-model="warehouseForm.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="结算方式" prop="address">
          <el-select size="small" v-model="warehouseForm.address">
            <el-option :value="null" label="全部"></el-option>
            <el-option :value="1" label="先货后款"></el-option>
            <el-option :value="2" label="先款后货"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addProductDialog = false, addDistributorDialog = false">取消</el-button>
        <el-button type="primary" @click.native="submitSetPrice">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑" :visible.sync="editDialog" v-if="editDialog" v-model="editDialog"
      :close-on-click-modal="false">
      <el-form :model="warehouseForm" label-width="120px" :rules="warehouseFormRules" ref="warehouseForm">
        <el-form-item label="分销商名称" prop="name">
          <el-input v-model="warehouseForm.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="结算方式" prop="address">
          <el-select size="small" v-model="warehouseForm.address">
            <el-option :value="null" label="全部"></el-option>
            <el-option :value="1" label="先货后款"></el-option>
            <el-option :value="2" label="先款后货"></el-option>
          </el-select>
        </el-form-item>
        API对接状态：已对接
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false">取消</el-button>
        <el-button type="primary" @click.native="submitSetPrice">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="商品同步" :visible.sync="proSyncDialog" v-if="proSyncDialog" v-model="proSyncDialog"
      :close-on-click-modal="false" width="75%">
      <el-table border :data="syncList" :header-cell-style="{ background: '#F3F3F3' }" id="act-set-table">
        <el-table-column prop="distributor" min-width="120" align="center" label="分销商名称">
        </el-table-column>
        <el-table-column prop="proNum" min-width="120" align="center" label="需同步商品数">
        </el-table-column>
        <el-table-column min-width="100" align="center" label="操作">
          <template slot-scope="scope">
            <el-button @click="oneKeySync(scope.row)" type="primary" size="small">一键同步</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="proSyncDialog = false">取消</el-button>
        <el-button type="primary" @click.native="submitOneKeySync">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="批量设置价格" :visible.sync="batchSetPriceDialog" v-if="batchSetPriceDialog"
      v-model="batchSetPriceDialog" :close-on-click-modal="false" width="75%">
      <el-table border :data="batchSetPriceList" :header-cell-style="{ background: '#F3F3F3' }" id="act-set-table">
        <el-table-column prop="proName" min-width="120" align="center" label="商品名称">
        </el-table-column>
        <el-table-column prop="distributor" min-width="120" align="center" label="分销商">
        </el-table-column>
        <el-table-column prop="specName" min-width="120" align="center" label="规格名称">
        </el-table-column>
        <el-table-column prop="costPrice" align="center" label="成本价">
        </el-table-column>
        <el-table-column label="供货价" min-width="120" align="center">
          <template slot-scope="scope">
            <el-input v-model="scope.row.supplyPrice" placeholder="请输入"></el-input>
          </template>
        </el-table-column>
        <el-table-column width="100" align="center" label="操作">
          <template slot-scope="scope">
            <el-radio-group v-model="scope.row.status">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchSetPriceDialog = false">取消</el-button>
        <el-button type="primary" @click.native="submitBatchSetPrice">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="添加供应商" :visible.sync="supplierDialog" :close-on-click-modal="false" :show-close="false"
      width="50%" center>
      <el-form ref="form" :model="supplier" label-width="100px">
        <el-form-item label="供应商名称">
          <el-input v-model.trim="supplier.proSupplierName"></el-input>
        </el-form-item>
        <el-form-item label="联系人">
          <el-input v-model="supplier.contactName"></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="supplier.contactNumber"></el-input>
        </el-form-item>
        <el-form-item label="地址">
          <el-cascader ref="myCascader" @change="changeselectedAreaNode" v-model="warehouseForm"
            :props="areaCascaderProps"></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址">
          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 9 }" placeholder="请输入内容"
            v-model="supplier.detailedAddress">
          </el-input>
        </el-form-item>
        <el-form-item label="是否有仓库">
          <el-radio-group v-model="supplier.hasWarehouse">
            <el-radio label="true">是</el-radio>
            <el-radio label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否启用">
          <el-radio-group v-model="supplier.isActive">
            <el-radio label="true">是</el-radio>
            <el-radio label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否自动采购">
          <el-radio-group v-model="supplier.isAutoPurchase">
            <el-radio label="true">是</el-radio>
            <el-radio label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addClose">取 消</el-button>
        <el-button type="primary" @click="createSupplier">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog v-if="editVisible" title="编辑供应商" :visible.sync="editVisible" :close-on-click-modal="false"
      :show-close="false" width="50%" center>
      <el-form ref="form" label-width="140px">
        <el-form-item label="供应商名称">
          <el-input v-model.trim="editSupplier.proSupplierName"></el-input>
        </el-form-item>
        <el-form-item label="联系人">
          <el-input v-model="editSupplier.contactName"></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="editSupplier.contactNumber"></el-input>
        </el-form-item>
        <el-form-item label="地址">
          <el-cascader ref="myCascader" @change="changeselectedAreaNode1" v-model="warehouseForm"
            :props="areaCascaderProps"></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址">
          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 9 }" placeholder="请输入内容"
            v-model="editSupplier.detailedAddress">
          </el-input>
        </el-form-item>
        <el-form-item label="是否有仓库">
          <el-radio-group v-model="editSupplier.hasWarehouse">
            <el-radio :label=true>是</el-radio>
            <el-radio :label=false>否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否启用">
          <el-radio-group v-model="editSupplier.isActive">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否自动采购">
          <el-radio-group v-model="editSupplier.isAutoPurchase">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="外部系统AppId" prop="remoteAppId">
          <el-input v-model="editSupplier.remoteAppId" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="外部系统AppSecret" prop="remoteAppSecret">
          <el-input v-model="editSupplier.remoteAppSecret" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="发票类型">
          <!--          <el-input v-model="distributorForm.invoiceType" auto-complete="off"></el-input>-->
          <el-select v-model="editSupplier.invoiceType" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发票抬头">
          <el-input v-model="editSupplier.invoiceRise" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="纳税人识别号">
          <el-input v-model="editSupplier.taxpayerNumber" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="地址">
          <el-input type="textarea" autosize placeholder="请输入内容" v-model="editSupplier.invoiceAddress">
          </el-input>
        </el-form-item>
        <el-form-item label="开户行">
          <el-input type="textarea" autosize placeholder="请输入内容" v-model="editSupplier.invoiceBank">
          </el-input>
        </el-form-item>
        <el-form-item label="银行账户">
          <el-input v-model="editSupplier.invoiceBankAccount" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="电话">
          <el-input v-model="editSupplier.invoiceMobile" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="开票公司名称" prop="companyName">
          <el-input v-model="editSupplier.companyName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="开票收件人手机号" prop="consigneeMobile">
          <el-input v-model="editSupplier.consigneeMobile" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="开票收件人名称" prop="consigneeName">
          <el-input v-model="editSupplier.consigneeName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="开票收件人地址" prop="ConsigneeAddress">
          <el-input v-model="editSupplier.consigneeAddress" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="自定义扩展">
          <div id="extend-content"></div>
          <div class="option">
            <div class="btn" @click="addExtension">+添加扩展</div>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editVisible = false">取 消</el-button>
        <el-button type="primary" @click="addOrUpdate">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="查看" :visible.sync="showDialog" width="40%" center>
      <el-form ref="form" :model="supplier" label-width="100px">
        <el-form-item label="供应商名称">
          <el-input v-model="showData.proSupplierName"></el-input>
        </el-form-item>
        <!--        <el-form-item label="联系人">-->
        <!--          <el-input v-model="supplier.name"></el-input>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="联系电话">-->
        <!--          <el-input v-model="supplier.name"></el-input>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="地址">-->
        <!--          <el-cascader ref="myCascader" @change="changeselectedAreaNode"  v-model="warehouseForm.area"-->
        <!--                       :props="areaCascaderProps"></el-cascader>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="详细地址">-->
        <!--          <el-input v-model="supplier.name"></el-input>-->
        <!--        </el-form-item>-->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showCloses">取 消</el-button>
        <el-button type="primary" @click="showConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <!--    点位设置-->
    <el-dialog title="自动点位设置" :show-close=false :visible.sync="pointDialog" width="40%" center>
      <el-form ref="form" label-width="100px">
        <el-form-item label="供货价提高">
          <el-input v-model.trim="pointSet">
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="pointClose">取 消</el-button>
        <el-button type="primary" @click="pointConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="绑定系统供应商" :visible.sync="sysDistributorDialog" v-if="sysDistributorDialog"
      v-model="sysDistributorDialog" :close-on-click-modal="false">
      <el-form :model="sysDistributorForm" label-width="120px" :rules="sysDistributorFormRules"
        ref="sysDistributorForm">
        <el-form-item label="系统供应商" prop="sysResellerId">
          <el-select filterable remote v-model="sysDistributorForm.sysSupplierName" placeholder="请选择系统供应商（可搜索）"
            clearable @change="selectSysSupplier" @clear='clearSysSupplierId'>
            <el-option v-for="(item, index) in sysDistributorList" :key="index" :label="item.value" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="sysDistributorDialog = false">取消</el-button>
        <el-button type="primary" :loading="submitLoading" @click.native="submitSysDistributor">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  CreateSupplier,
  GetAllSupplier,
  GetAllUser,
  CreateUser,
  GetUserDetail,
  UpdateUser,
  DeleteUser,
  GetRoles, GetAreaTree, GetAllArea, ChangeTenantPsd,
  SetAutoPurchaseState,
  SupplierUpdate, GetAllSysReseller, BindSysReseller, BindSysSupplier, SysSupplierGetAll, SetPriceProportion
} from "../../api/api";
import toolbar from "../../components/Toolbar";
import { getButtonList } from "../../promissionRouter";

export default {
  components: { toolbar },
  data() {
    let that = this;
    return {
      pointDialog: false,
      pointSet: null,
      pointRow: {},
      isAdd: true,
      sysDistributorForm: {
        sysSupplierId: null, // 系统供应商id
        sysSupplierName: '',
        id: null, //供应商id
      },
      sysDistributorFormRules: {
        sysSupplierId: [
          { required: true, message: '请选择系统供应商', trigger: 'change' }
        ]
      },
      sysDistributorDialog: false,
      editVisible: false,
      isShow: false,
      isEdit: false,
      isPoint: false,
      isFetchPro: false,
      isAutoPurchase: false,
      isBindSysDistributor: false,
      showDialog: false,
      showData: {
        id: null,
        proSupplierName: '',
      },
      searchData: {},
      extendList: [],
      options: [{
        value: '增值税专用发票',
        label: '增值税专用发票'
      }, {
        value: '增值税普通发票',
        label: '增值税普通发票'
      }],
      editSupplier: {
        proSupplierName: '',
        contactName: '',
        contactNumber: '',
        provinceId: '',
        province: '',
        cityId: '',
        city: '',
        hasWarehouse: null,
        isAutoPurchase: '',
        sysSupplierId: 0,
        isActive: '',
        districtId: '',
        district: '',
        detailedAddress: '',
        id: null,
        remoteAppSecret: '',
        remoteAppId: '',
        extensionJson: '',
        invoiceRise: '',
        consigneeMobile: '',
        companyName: '',
        consigneeName: '',
        consigneeAddress: '',
        taxpayerNumber: '',
        invoiceAddress: '',
        invoiceBank: '',
        invoiceBankAccount: '',
        invoiceMobile: '',
        invoiceType: '',
      },
      supplier: {
        proSupplierName: '',
        contactName: '',
        contactNumber: null,
        provinceId: '',
        province: '',
        cityId: '',
        city: '',
        hasWarehouse: '',
        isAutoPurchase: '',
        sysSupplierId: 0,
        isActive: '',
        districtId: '',
        district: '',
        detailedAddress: ''
      },
      editDialog: false,
      warehouseFormVisible: false,
      // warehouseForm: {
      //   name: null,
      //   area: null,
      //   address: null
      // },
      warehouseForm: [],
      warehouseFormRules: {
        name: [
          { required: true, message: '请输入仓库名', trigger: 'blur' },
          { message: '请输入仓库名', trigger: ['blur', 'change'] }
        ],
        area: [
          { type: 'array', required: true, message: '请选择所在省份', trigger: 'change' }
        ],
        address: [
          { required: true, message: '请输入详细地址', trigger: 'blur' },
          { message: '请输入详细地址', trigger: ['blur', 'change'] }
        ],
      },

      buttonList_toolBar: [],
      buttonList_table: [],

      tableLoading: false,
      currentRow: [],
      total: 0,
      queryForm: {
        PageIndex: 1,
        PageSize: 10,
        SupplierName: '',
        isAccess: null,
        aa: 1

      },
      isAccess: null,
      userList: [],
      submitLoading: false,

      addProductDialog: false,
      addProductForm: {
        SpuId: null,
        ProName: null,
        ProCode: null,
        ProTypeId: null,
        ProBrandId: null,
        pageIndex: 1,
        pageSize: 10
      },
      addProductList: [
        {
          SpuId: 11,
          ProName: 'pro1',
          ProTypeName: '自有',
          ProBrandName: '美的',
          ProCode: 222,
          CostPrice: 11111
        },
        {
          SpuId: 22,
          ProName: 'pro2',
          ProTypeName: '自有',
          ProBrandName: '海尔',
          ProCode: 22222,
          CostPrice: 3333
        },
        {
          SpuId: 22,
          ProName: 'pro2',
          ProTypeName: '自有',
          ProBrandName: '海尔',
          ProCode: 22222,
          CostPrice: 3333
        },
        {
          SpuId: 22,
          ProName: 'pro2',
          ProTypeName: '自有',
          ProBrandName: '海尔',
          ProCode: 22222,
          CostPrice: 3333
        },
        {
          SpuId: 22,
          ProName: 'pro2',
          ProTypeName: '自有',
          ProBrandName: '海尔',
          ProCode: 22222,
          CostPrice: 3333
        }
      ],

      addDistributorDialog: false,
      setPriceList: [
        {
          proName: 'cc',
          distributor: 'cc',
          specName: 'dd',
          costPrice: 'dd',
          supplyPrice: 'dd',
          status: null
        },
        {
          proName: 'cc',
          distributor: 'cc',
          specName: 'dd',
          costPrice: 'dd',
          supplyPrice: 'dd',
          status: null
        },
      ],

      proSyncDialog: false,
      syncList: [
        {
          distributor: 'cc',
          proNum: 'cc'
        },
        {
          distributor: 'cc',
          proNum: 'cc'
        },
      ],

      batchSetPriceDialog: false,
      batchSetPriceList: [
        {
          proName: 'cc',
          distributor: 'cc',
          specName: 'dd',
          costPrice: 'dd',
          supplyPrice: 'dd',
          status: null
        },
        {
          proName: 'cc',
          distributor: 'cc',
          specName: 'dd',
          costPrice: 'dd',
          supplyPrice: 'dd',
          status: null
        },
      ],
      supplierDialog: false,
      areaTreeList: [],
      areaCascaderProps: {
        lazy: true,
        lazyLoad(node, resolve) {
          that.renderAreaCascader(resolve, node.level, node);
        },
      },
      statusOptions: [{
        value: 'true',
        label: '已对接'
      }, {
        value: 'false',
        label: '未对接'
      }],
    };
  },
  mounted() {
    window.deleteExtendBox = this.deleteExtendBox;
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);

    //第二种写法，封装到 permissionRouter.js 中
    var buttonList = getButtonList(this.$route.path, routers);
    if (buttonList && buttonList.length > 0) {
      const toolBarButtonList = buttonList.filter((item) => {
        return item.buttonShow === 10;
      });
      this.buttonList_toolBar = toolBarButtonList;
      const tableButtonList = buttonList.filter((item) => {
        return item.buttonShow === 20;
      });
      this.buttonList_table = tableButtonList;
      console.log(' this.buttonList_toolBar', this.buttonList_toolBar);
      this.buttonList_table && this.buttonList_table.forEach((item) => {
        if (item.buttonFunc === 'show') {
          this.isShow = true;
        }
      })
      this.buttonList_table && this.buttonList_table.forEach((item) => {
        if (item.buttonFunc === 'fetchPro') {
          this.isFetchPro = true;
        }
      })
      this.buttonList_table && this.buttonList_table.forEach((item) => {
        if (item.buttonFunc === 'autoPurchase') {
          this.isAutoPurchase = true;
        }
      })

      this.buttonList_table && this.buttonList_table.forEach((item) => {
        if (item.buttonFunc === 'bindSysDistributor') {
          this.isBindSysDistributor = true;
        }
      })

      this.buttonList_table && this.buttonList_table.forEach((item) => {
        if (item.buttonFunc === 'supplierEdit') {
          this.isEdit = true;
        }
      })
      this.buttonList_table && this.buttonList_table.forEach((item) => {
        if (item.buttonFunc === 'pointSet') {
          this.isPoint = true;
        }
      })
    }
    this.renderButton();

  },
  created() {
    this.renderAreaTree();
    this.allSupplier();
    this.getsysDistributorList();
  },
  methods: {
    pointClose() {
      this.pointDialog = false;
      this.pointSet = null;
      this.pointRow = {};
    },
    pointConfirm(row) {
      // if (!this.pointSet){
      //   return this.$message.error('请填写点位设置');
      // }
      // let regx = /^(?:[1-9]\d*|0)(?:\.\d{1,2})?$/;
      //
      // if (!regx.test(this.pointSet)){
      //   return this.$message.error('请填正确的数据');
      // }
      let params = {};
      params.Id = this.pointRow.id;
      params.ProSupplierName = this.pointRow.proSupplierName;
      params.PriceProportion = this.pointSet;

      this.$confirm(`确认设置此点位吗?`, "提示", {
        closeOnClickModal: false,
      }).then(async () => {
        let res = await SetPriceProportion(params);
        console.log('点位设置', res);
        if (res.data.success) {
          this.$message.success(res.data.msg || '设置成功')
          this.pointDialog = false;
          this.pointRow = [];
          await this.allSupplier();
        } else {
          this.$message.error(res.data.error.message || '设置失败, 请重试')
        }
      }).catch(() => {
      });
    },
    setPoint(row) {
      this.pointDialog = true;
      this.pointRow = row;
      this.pointSet = row.priceProportion;
      console.log('row.priceProportion;', row.priceProportion)
      console.log('setpont', row);

    },
    clearSysSupplierId(val) {
      console.log('clear')
      this.sysDistributorForm.sysSupplierId = null;
    },
    selectSysSupplier(val) {
      console.log(val)
      this.sysDistributorForm.sysSupplierId = val;
    },
    addExtension() {
      let html = `
        <div class="extend-box">
          key：&nbsp;&nbsp;
          <input class="input-piece1" type="text">
          &nbsp;&nbsp;value：&nbsp;&nbsp;
          <input class="input-piece1" type="text">
          <div class="delete-icon" onclick="deleteExtendBox(this)">
            <img />
          </div>
        </div>
      `;
      let rebateContent = document.getElementById('extend-content');
      rebateContent.insertAdjacentHTML('beforeend', html);
    },
    submitSysDistributor() {
      let that = this;
      // console.log('this.sysDistributorForm;',this.sysDistributorForm);return;
      that.$refs.sysDistributorForm.validate((valid) => {
        if (valid) {
          that.$confirm("确认提交吗？", "提示", {
            closeOnClickModal: false,
          }).then(() => {
            that.submitLoading = true;
            BindSysSupplier(that.sysDistributorForm).then((res) => {
              that.submitLoading = false;
              if (res.data.success) {
                that.$message.success('绑定成功');
                that.sysDistributorDialog = false;
                that.allSupplier();
              } else {
                that.$message.error(res.data.error.message);
              }
            });
          }).catch(() => {
          });
        }
      });
    },
    getsysDistributorList() {
      let params = {
        SkipCount: 0,
        MaxResultCount: 200
      };
      SysSupplierGetAll(params).then((res) => {
        console.log('BindSysSupplier res', res);
        if (res.data.success) {
          this.sysDistributorList = res.data.result.items.map(item => {
            return { id: item.id, value: item.name }
          });
        }
      });
    },
    emptyErrStyle(elements) {
      for (var i = 0, len = elements.length; i < len; i++) {
        let input = elements[i];
        let extendBox = input.closest('.extend-box');
        input.classList.remove("input-err");
        extendBox.classList.remove("box-err");
      }
    },
    addOrUpdate() {
      if (this.isAdd) {
        this.createSupplier();
      } else {
        this.updateSupplier();
      }
    },
    async updateSupplier() {
      console.log('编辑', this.editSupplier);
      if (!this.editSupplier.proSupplierName) {
        return this.$message.error('请输入供应商名称')
      }
      if (!this.editSupplier.contactName) {
        return this.$message.error('请输入联系人')
      }
      let myreg = /^1[3-9]\d{9}$/;
      if (!myreg.test(this.editSupplier.contactNumber)) {
        return this.$message.error('请输入正确的联系电话')
      }
      if (!this.editSupplier.province || !this.editSupplier.provinceId
        || !this.editSupplier.city || !this.editSupplier.cityId
        || !this.editSupplier.district || !this.editSupplier.districtId) {
        return this.$message.error('地址有误, 请重试')
      }
      // if (!this.editSupplier.hasWarehouse) {
      //   return this.$message.error('请确定是否有仓库')
      // }
      // if (!this.editSupplier.isAutoPurchase) {
      //   return this.$message.error('请选择开启或者关闭自动采购')
      // }
      // if (!this.editSupplier.isActive) {
      //   return this.$message.error('请选择开启状态')
      // }

      if (!this.editSupplier.detailedAddress) {
        return this.$message.error('请输入详细地址')
      }
      // 处理扩展字段
      var elements = document.querySelectorAll('#extend-content input');
      this.emptyErrStyle(elements);
      for (var i = 0, len = elements.length; i < len; i++) {
        let input = elements[i];
        if (input.value == "") {
          let extendBox = input.closest('.extend-box');
          this.$message.error('不能为空');
          input.classList.add("input-err");
          extendBox.classList.add("box-err");
          return;
        }
      }
      this.extendList = [];
      for (var i = 0, len = elements.length; i < len; i++) {
        this.extendList.push({
          key: elements[i].value,
          value: elements[i + 1].value
        });
        i += 1;
      }
      this.editSupplier.extensionJson = JSON.stringify(this.extendList);

      console.log('this.editSupplier', this.editSupplier)
      let res = await SupplierUpdate(this.editSupplier);
      // console.log('添加结果', res)
      if (res.data.success) {
        this.editVisible = false;
        await this.allSupplier();
      } else {
        this.$message.error(res.data.result.message || '查询失败, 请重试');
      }
    },
    deleteExtendBox(e) {
      let parent = e.closest('.extend-box');
      parent.parentNode.removeChild(parent);
    },
    supplierEdit(row) {
      console.log('bianji', row)
      this.warehouseForm = [];
      this.warehouseForm.push(row.provinceId);
      this.warehouseForm.push(row.cityId);
      this.warehouseForm.push(row.districtId);
      // console.log('this.warehouseForm',this.warehouseForm);
      this.editSupplier.proSupplierName = row.proSupplierName
      this.editSupplier.contactName = row.contactName
      this.editSupplier.contactNumber = row.contactNumber
      this.editSupplier.provinceId = row.provinceId
      this.editSupplier.province = row.province
      this.editSupplier.cityId = row.cityId
      this.editSupplier.city = row.city
      this.editSupplier.hasWarehouse = row.hasWarehouse
      this.editSupplier.isAutoPurchase = row.isAutoPurchase
      this.editSupplier.sysSupplierId = row.sysSupplierId
      this.editSupplier.isActive = row.isActive
      this.editSupplier.districtId = row.districtId
      this.editSupplier.district = row.district
      this.editSupplier.detailedAddress = row.detailedAddress
      this.editSupplier.id = row.id
      this.editSupplier.remoteAppId = row.remoteAppId
      this.editSupplier.remoteAppSecret = row.remoteAppSecret
      this.editSupplier.invoiceRise = row.invoiceRise
      this.editSupplier.consigneeMobile = row.consigneeMobile
      this.editSupplier.companyName = row.companyName
      this.editSupplier.consigneeName = row.consigneeName
      this.editSupplier.consigneeAddress = row.consigneeAddress
      this.editSupplier.taxpayerNumber = row.taxpayerNumber
      this.editSupplier.invoiceAddress = row.invoiceAddress
      this.editSupplier.invoiceBank = row.invoiceBank
      this.editSupplier.invoiceBankAccount = row.invoiceBankAccount
      this.editSupplier.invoiceMobile = row.invoiceMobile
      this.editSupplier.invoiceType = row.invoiceType
      this.$nextTick(() => {
        if (row.extensionJson) {
          let extendData = JSON.parse(row.extensionJson) || [];
          if (extendData.length > 0) {
            let html = "";
            for (var i = 0; i < extendData.length; i++) {
              var el = extendData[i];
              let key = el.key;
              let value = el.value;
              html += "<div class=\"extend-box\">key：&nbsp;&nbsp;<input class=\"input-piece1\" type=\"text\" value=" + key + ">&nbsp;&nbsp;value：&nbsp;&nbsp;<input class=\"input-piece1\" type=\"text\" value=" + value + "><div class=\"delete-icon\" onclick=\"deleteExtendBox(this)\"><img /></div></div>";
            }
            let rebateContent = document.getElementById('extend-content');
            rebateContent.insertAdjacentHTML('beforeend', html);
          }
        }
      });

      this.editVisible = true;
      this.isAdd = false;
    },
    changeStatus(val) {
      // console.log(this.queryForm, val);
      this.queryForm.isAccess = val;
    },
    autoPurchase(row) {
      this.$confirm(`确认${row.isAutoPurchase ? '关闭' : '开启'}自动采购吗?`, "提示", {
        closeOnClickModal: false,
      }).then(() => {
        let params = {};
        params.id = row.id;
        params.isAutoPurchase = !row.isAutoPurchase;
        // console.log('caigou', row);return;
        SetAutoPurchaseState(params).then((res) => {
          // console.log('采购', res);
          if (res.data.success) {
            this.$message.success('修改成功');
            this.allSupplier();
          } else {
            this.$message.error(res.data.error.message)
          }
        });
      }).catch(() => {
      });
    },
    addClose() {
      this.supplierDialog = false;
      this.supplier = {
        proSupplierName: '',
        contactName: '',
        contactNumber: '',
        provinceId: '',
        province: '',
        cityId: '',
        city: '',
        hasWarehouse: '',
        isAutoPurchase: '',
        sysSupplierId: 0,
        isActive: '',
        districtId: '',
        district: '',
        detailedAddress: ''
      }
      this.warehouseForm = [];
    },
    showCloses() {
      this.showDialog = false;
      this.showData = {
        id: null,
        proSupplierName: '',
      };
      this.warehouseForm = [];
    },
    showConfirm() {
      this.showDialog = false;
      this.showData = {
        id: null,
        proSupplierName: '',
      }
    },
    async allSupplier() {

      // console.log('54632132131223')
      // console.log(13123)
      this.queryForm.SkipCount = (this.queryForm.PageIndex - 1) * this.queryForm.PageSize;
      this.queryForm.MaxResultCount = this.queryForm.PageSize;

      let res = await GetAllSupplier(this.queryForm);
      // console.log('-----共供应商列表---', res);
      if (res.data.success) {
        this.userList = res.data.result.items
        this.total = res.data.result.totalCount
      } else {
        this.$message.error(res.data.result.message || '查询失败, 请重试')
      }
    },
    renderAreaCascader(resolve, level, node) {
      let params = {
        SkipCount: 0,
        MaxResultCount: 100
      };
      if (level == 0) {
        params.ParentId = 0;
      } else {
        params.ParentId = node.data.id;
      }
      GetAllArea(params).then((res) => {
        let arr = res.data.result.items.map((e) => ({ id: e.id, value: e.id, label: e.name, leaf: level >= 2 }));
        resolve(arr);
      });
    },
    // callFunction(item) {
    //   this[item.buttonFunc](this, item);
    // },
    callFunctionRow(item, index, row) {
      this[item.buttonFunc](item, index, row);
    },
    renderAreaTree() {
      // console.log('323324324')
      let params = {
        MaxLevel: 3
      };
      GetAreaTree(params).then((res) => {
        this.areaTreeList = this.loopTree(res.data.result.children);
        // console.log(' this.areaTreeList', this.areaTreeList)
      });
    },
    loopTree(treeList, lastFullId) {
      const newList = treeList.filter(item => {
        let Level = item.data.Level;
        item.Level = Level;
        item.areaId = item.data.Id;
        item.areaName = item.data.Name;
        item.id = item.data.Id;
        item.label = item.data.Name;
        let nowFullId;
        if (Level == 1) nowFullId = '' + item.data.Id;
        if (Level == 2) nowFullId = [item.data.ParentId, item.data.Id].join(",");
        if (Level == 3) nowFullId = lastFullId + ',' + item.data.Id;
        item.areaFullId = nowFullId;
        delete item.data
        if (!item.children.length) {
          delete item.children
        } else {
          this.loopTree(item.children, item.areaFullId)
        }
        return true;
      })
      return newList;
    },

    changeselectedAreaNode() {
      let selectedAreaNode = this.$refs.myCascader.getCheckedNodes()[0].pathNodes;
      // console.log('selectedAreaNode', selectedAreaNode);
      selectedAreaNode.forEach((item, index) => {
        if (item.level === 1) {
          this.supplier.provinceId = item.value;
          this.supplier.province = item.label;
        }
        if (item.level === 2) {
          this.supplier.cityId = item.value;
          this.supplier.city = item.label;
        }
        if (item.level === 3) {
          this.supplier.districtId = item.value;
          this.supplier.district = item.label;
        }
      })
      // selectedAreaNode.item
    },
    changeselectedAreaNode1() {
      let selectedAreaNode = this.$refs.myCascader.getCheckedNodes()[0].pathNodes;
      // console.log('selectedAreaNode', selectedAreaNode);
      selectedAreaNode.forEach((item, index) => {
        if (item.level === 1) {
          this.editSupplier.provinceId = item.value;
          this.editSupplier.province = item.label;
        }
        if (item.level === 2) {
          this.editSupplier.cityId = item.value;
          this.editSupplier.city = item.label;
        }
        if (item.level === 3) {
          this.editSupplier.districtId = item.value;
          this.editSupplier.district = item.label;
        }
      })
      // selectedAreaNode.item
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 1) {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    addProduct() {
      this.addProductDialog = true;
    },
    renderButton() {
      let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
      var buttonList = getButtonList(this.$route.path, routers);
      this.buttonList_toolBar = buttonList.filter((item) => {
        return item.buttonShow == 10 && item.isVisible;
      });
      this.buttonList_table = this.$utils.sortDataArrayAsc(buttonList.filter((item) => {
        return item.buttonShow == 20 && item.isVisible;
      }), 'order');
    },
    callFunction(item) {
      this[item.buttonFunc](item);
    },
    getUserList() {
      this.tableLoading = true;
      let params = {
        Keyword: this.queryForm.Keyword,
        IsActive: this.queryForm.IsActive,
        SkipCount: (this.queryForm.pageIndex - 1) * 10,
        MaxResultCount: this.queryForm.pageSize
      }
      let that = this;
      GetAllUser(params).then((res) => {
        that.tableLoading = false;
        that.total = res.data.result.totalCount;
        that.userList = res.data.result.items;
      });
    },
    handleSelectionChange(val) {
      this.currentRow = val;
    },
    handleCurrentChange(val) {
      // console.log(val)
      this.queryForm.PageIndex = val;
      this.allSupplier();
    },
    handleSizeChange(val) {
      // console.log(val)
      this.queryForm.PageSize = val;
      this.allSupplier();
    },
    search() {
      this.queryForm.pageIndex = 1;
      this.queryForm.pageSize = 10;
      this.allSupplier();
    },
    empty() {
      this.queryForm = {
        PageIndex: 1,
        PageSize: 10,
        SupplierName: '',
        isAccess: null
      };
      this.isAccess = null;
      this.allSupplier();
    },
    addUser() {
      this.userFormVisible = true;
      this.isEdit = false;
      this.userForm = {
        userName: null,
        name: null,
        surname: null,
        password: null,
        emailAddress: null,
        isActive: true,
        roleNames: []
      }
    },
    editUser() {
      let row = this.currentRow;
      if (!row) {
        return this.$message.error('请选择要编辑的一行数据！');
      }
      let params = { Id: row.id };
      let that = this;
      GetUserDetail(params).then((res) => {
        if (res.data.success) {
          that.userForm = res.data.result;
          that.isEdit = true;
          that.userFormVisible = true;
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    delUser() {
      let row = this.currentRow;
      if (!row) {
        return this.$message.error('请选择要删除的一行数据！');
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
        closeOnClickModal: false,
      }).then(() => {
        this.tableLoading = true;
        let params = { Id: row.id };
        let that = this;
        DeleteUser(params).then((res) => {
          that.tableLoading = false;
          if (res.data.success) {
            that.$message.success('删除成功');
            that.getUserList();
          } else {
            that.$message.error(res.data.msg);
          }
        });
      }).catch(() => {
      });
    },
    submitUser() {
      let that = this;
      that.$refs.userForm.validate((valid) => {
        if (valid) {
          that.$confirm("确认提交吗？", "提示", {
            closeOnClickModal: false,
          }).then(() => {
            that.submitLoading = true;
            if (!that.isEdit) {
              // surname必填且不能为空、不能为空字符串。。。
              that.userForm.surname = that.userForm.name;
              CreateUser(that.userForm).then((res) => {
                that.submitLoading = false;
                if (res.data.success) {
                  that.$message.success('新增成功');
                  that.userFormVisible = false;
                  that.getUserList();
                } else {
                  that.$message.error(res.data.msg);
                }
              });
            } else {
              UpdateUser(that.userForm).then((res) => {
                that.submitLoading = false;
                if (res.data.success) {
                  that.$message.success('修改成功');
                  that.userFormVisible = false;
                  that.getUserList();
                } else {
                  that.$message.error(res.data.error.message)
                }
              });
            }
          }).catch(() => {
          });
        }
      });
    },
    getRolesList() {
      let that = this;
      GetRoles().then((res) => {
        that.roleList = res.data.result.items;
      });
    },
    setRoles() {
      let row = this.currentRow;
      if (!row) {
        return this.$message.error('请选择一行数据！');
      }
      let params = { Id: row.id };
      let that = this;
      GetUserDetail(params).then((res) => {
        if (res.data.success) {
          that.userForm = res.data.result;
          that.addDistributorDialog = true;
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    submitAddPro() {
      this.addDistributorDialog = true;
      // this.$confirm("确认提交吗？", "提示", {
      //   closeOnClickModal: false,
      // }).then(() => {
      //   this.submitLoading = true;
      //   let that = this;
      //   UpdateUser(that.userForm).then((res) => {
      //     that.submitLoading = false;
      //     if (res.data.success) {
      //       that.$message.success('提交成功');
      //       that.addDistributorDialog = false;
      //     } else {
      //       that.$message.error(res.data.error.message)
      //     }
      //   });
      // }).catch(() => {});
    },
    submitSetPrice() {
      let flag = true;
      try {
        this.setPriceList.forEach(x => {
          if (!x.supplyPrice && x.supplyPrice == '') {
            flag = false;
            this.$message.error('请输入供货价！');
            throw Error();
          }
          if (!/^[0-9]+(.[0-9]{1,2})?$/.test(x.supplyPrice)) {
            flag = false;
            this.$message.error('供货价必须为数字（可保留两位小数）');
            throw Error();
          }
          if (!x.status) {
            flag = false;
            this.$message.error('请选择上下架！');
            throw Error();
          }
        });
      } catch (e) {
      }
      if (flag) {
        this.$confirm("本次操作是否同步相应的分销商？", "提示", {
          closeOnClickModal: false,
        }).then(() => {
          // 调用接口，并同步
          this.addDistributorDialog = false;
          this.addProductDialog = false;
        }).catch(() => {
          // 调用接口，不同步
          this.addDistributorDialog = false;
          this.addProductDialog = false;
        });
      }
    },
    productSync() {
      this.proSyncDialog = true;
    },
    submitOneKeySync() {

    },
    batchSetPrice() {
      if (this.currentRow.length == 0) {
        return this.$message.error('请选择一行数据！');
      }
      this.batchSetPriceDialog = true;
    },
    submitBatchSetPrice() {
      let flag = true;
      try {
        this.batchSetPriceList.forEach(x => {
          if (!x.supplyPrice && x.supplyPrice == '') {
            flag = false;
            this.$message.error('请输入供货价');
            throw Error();
          }
          if (!/^[0-9]+(.[0-9]{1,2})?$/.test(x.supplyPrice)) {
            flag = false;
            this.$message.error('供货价必须为数字（可保留两位小数）');
            throw Error();
          }
        });
      } catch (e) {
      }
      if (flag) {
        this.$confirm("本次操作是否同步相应的分销商？", "提示", {
          closeOnClickModal: false,
        }).then(() => {
          // 调用接口，并同步
          this.batchSetPriceDialog = false;
        }).catch(() => {
          // 调用接口，不同步
          this.batchSetPriceDialog = false;
        });
      }
    },
    batchOffShelf() {
      if (this.currentRow.length == 0) {
        return this.$message.error('请选择一行数据！');
      }
    },
    batchShelves() {
      if (this.currentRow.length == 0) {
        return this.$message.error('请选择一行数据！');
      }
    },
    batchImport() {
      if (this.currentRow.length == 0) {
        return this.$message.error('请选择一行数据！');
      }
    },
    offTheShelf(params) {
      let row = params.funcParams;
    },
    productSync_tab(params) {
      let row = params.funcParams;
      if (!row.supplyPrice || row.supplyPrice == '') {
        var elements = document.querySelectorAll('#user-table .el-table__body-wrapper')[0];
        let scrollWidth = elements.scrollWidth;
        elements.scrollLeft = scrollWidth;
        return this.$message.error('请输入供货价格！');
      }
    },
    detail(params) {
      let row = params.funcParams;
    },
    addDistributor() {
      this.addDistributorDialog = true;
    },
    edit() {
      this.editDialog = true;
    },
    licensedGoods(params) {
      let row = params.funcParams;
      this.$router.push(`/Sale/LicensedGoods`);
    },
    addSupplier(button, index, row) {
      this.isAdd = true;
      this.editVisible = true;
      this.editSupplier = {
        proSupplierName: '',
        contactName: '',
        contactNumber: '',
        provinceId: '',
        province: '',
        cityId: '',
        city: '',
        hasWarehouse: '',
        isAutoPurchase: '',
        sysSupplierId: 0,
        isActive: '',
        districtId: '',
        district: '',
        detailedAddress: '',
        id: null,
        remoteAppSecret: '',
        remoteAppId: '',
        extensionJson: '',
        invoiceRise: '',
        consigneeMobile: '',
        companyName: '',
        consigneeName: '',
        consigneeAddress: '',
        taxpayerNumber: '',
        invoiceAddress: '',
        invoiceBank: '',
        invoiceBankAccount: '',
        invoiceMobile: '',
        invoiceType: '',
      };
      this.warehouseForm = [];
    },

    async createSupplier() {
      console.log('add', this.editSupplier)
      if (!this.editSupplier.proSupplierName) {
        return this.$message.error('请输入供应商名称')
      }
      if (!this.editSupplier.contactName) {
        return this.$message.error('请输入联系人')
      }
      let myreg = /^1[3-9]\d{9}$/;
      if (!myreg.test(this.editSupplier.contactNumber || !this.editSupplier.contactNumber)) {
        return this.$message.error('请输入正确的联系电话')
      }
      if (!this.editSupplier.province || !this.editSupplier.provinceId
        || !this.editSupplier.city || !this.editSupplier.cityId
        || !this.editSupplier.district || !this.editSupplier.districtId) {
        return this.$message.error('地址有误, 请重试')
      }
      if (this.editSupplier.hasWarehouse === null) {
        return this.$message.error('请确定是否有仓库')
      }
      if (this.editSupplier.isAutoPurchase === null) {
        return this.$message.error('请选择开启或者关闭自动采购')
      }
      if (this.editSupplier.isActive === null) {
        return this.$message.error('请选择开启状态')
      }
      if (!this.editSupplier.detailedAddress) {
        return this.$message.error('请输入详细地址')
      }
      // 处理扩展字段
      var elements = document.querySelectorAll('#extend-content input');
      this.emptyErrStyle(elements);
      for (var i = 0, len = elements.length; i < len; i++) {
        let input = elements[i];
        if (input.value == "") {
          let extendBox = input.closest('.extend-box');
          this.$message.error('不能为空');
          input.classList.add("input-err");
          extendBox.classList.add("box-err");
          return;
        }
      }
      this.extendList = [];
      for (var i = 0, len = elements.length; i < len; i++) {
        this.extendList.push({
          key: elements[i].value,
          value: elements[i + 1].value
        });
        i += 1;
      }
      this.editSupplier.extensionJson = JSON.stringify(this.extendList);

      console.log('this.editSupplier', this.editSupplier)
      let res = await CreateSupplier(this.editSupplier);
      // console.log('添加结果', res);

      if (res.data.success) {
        this.editVisible = false;
        await this.allSupplier();
      } else {
        this.$message.error(res.data.result.message || '查询失败, 请重试');
      }
    },
    export() {

    },
    show(row) {

      this.showDialog = true;
      // console.log('show', row);
      this.showData.id = row.id;
      this.showData.proSupplierName = row.proSupplierName;
    },
    fetchPro(params) {
      console.log('params', params)
      let row = params.funcParams;
      this.$router.push(`/Sale/FetchProduct?id=${params.id}`);
    },
    bindSysDistributor(row) {
      console.log('bind')
      // let row = params.funcParams;
      this.sysDistributorForm.id = row.id;
      this.sysDistributorForm.sysSupplierId = row.sysSupplierId;
      this.sysDistributorForm.sysSupplierName = row.sysSupplierName;
      // this.sysDistributorForm.sysResellerId = row.sysResellerId;
      this.sysDistributorDialog = true;
    }
  }
};
</script>
<style scoped>
#main-box {
  width: 100%;
  height: 100%;
}

#content-box {
  /* padding: 0 20px 20px 20px;
  width: 100%;
  height: 100%; */
}

#main-box /deep/ .el-pagination {
  /* padding: 10px 5px; */
}

#main-box /deep/ #extend-content {
  padding: 20px 0 0 0;
  max-height: 200px;
  overflow-y: auto;
}

#main-box /deep/ #extend-content::-webkit-scrollbar {
  width: 8px;
}

#main-box /deep/ #extend-content::-webkit-scrollbar-track {
  background-color: #F1F1F1;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
}

#main-box /deep/ #extend-content::-webkit-scrollbar-thumb {
  background-color: #C1C1C1;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
}

#main-box /deep/ .extend-box {
  width: 360px;
  height: 34px;
  position: relative;
  display: flex;
  justify-content: flex-start;
  border-radius: 6px;
  padding: 3px 10px;
}

#main-box /deep/ .extend-box.box-err {
  background-color: #FEF0F0;
}

#main-box /deep/ .extend-box input {
  width: 70px !important;
  height: 100% !important;
  line-height: 36px;
  -webkit-appearance: none;
  background-color: #FFF;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  height: 40px;
  line-height: 40px;
  outline: 0;
  padding: 0 15px;
  -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
}

#main-box /deep/ .extend-box input.input-err {
  border: #F56C6C solid 1px;
}

#main-box /deep/ .delete-icon {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 15px;
}

#main-box /deep/ .delete-icon img {
  width: 20px;
  height: 20px;
  content: url(../../assets/close.png);
  cursor: pointer;
}

#main-box /deep/ .delete-icon img:hover {
  transform: scale(1.2);
}

#main-box /deep/ .option {
  width: 330px;
  display: flex;
  justify-content: space-between;
}

#main-box /deep/ .option .btn {
  color: #409EFF;
  cursor: pointer;
}

#main-box /deep/ .el-dialog__body {
  padding: 10px 20px 0 20px;
}

#main-box /deep/ .el-dialog__body .el-form-item {
  margin-bottom: 15px;
}

#main-box /deep/ .el-dialog__footer {
  padding: 0 20px 20px 20px;
}

#main-box /deep/ .dialog-footer {
  padding: 0 20px 0 20px;
}

.tool_box {
  padding-top: 20px;
  overflow: hidden;
}

.flex {
  display: flex
}

.flex-center {
  align-items: center;
}

.data-detail-wrap {
  padding: 30px;
}

.data-detail-wrap .dataBox {
  margin-top: 40px;
}

.elSelect {
  width: 200px;
}

.el-dialog {
  padding-bottom: 0;
}

.img_box {
  width: 120px;
  height: 120px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  position: relative;
  margin-right: 10px;
  display: inline-block;
}

.img_box img {
  height: 100%;
  width: 100%;
  border-radius: 6px;
}

.del_box {
  position: absolute;
  top: -15px;
  right: -10px;
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.play_btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  z-index: 2;
}

.play_btn i {
  font-size: 25px;
  color: #666;
  border: 1px solid #666;
  border-radius: 50%;
  cursor: pointer;
}

.del_box img {
  height: 100%;
  width: 100%;
}

.avatar-uploader {
  display: inline-block;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.video-uploader {
  display: inline-block;
}

.video-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.videoWrap {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  background: rgba(0, 0, 0, .6);
}

.videoWrapInner {
  background: white;
  width: 600px;
  height: 400px;
}

.picPreview {
  display: flex;
  margin-bottom: 15px;
}

.picPreview div {
  width: 120px;
  height: 120px;
  overflow: hidden;
  margin-right: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  position: relative;
}

.del {
  position: absolute;
  top: 0;
  right: 0;
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.del img {
  height: 100%;
  width: 100%;
}
</style>
